export const getStablishments = async (resource) => {
    let stablishment;
    await resource
      .get(`api/${localStorage.getItem('perfil')}/stablishment`)
      .then(
        (response) => {
          console.log(response);
          stablishment = response.body.data;
        },
        (response) => {
          console.log(response);
        }
      );
    return stablishment;
  }
  